// React/finance-app/src/features/tt-insights/tabs/WeeklyRebatesTab.jsx
import React from 'react';
import ExportButton from '../ExportButton';

const WeeklyRebatesTab = ({ loading, rebatesCurNZ, rebatesPrev1NZ, rebatesPrev2NZ }) => (
  <div className="card mb-4">
    <div className="card-header">All Users – Rebates (Current & Previous 2 Weeks)</div>
    <div className="card-body table-responsive">
      {!loading && (
        <div className="mb-2 d-flex justify-content-end">
          <ExportButton
            disabled={(rebatesCurNZ.length + rebatesPrev1NZ.length + rebatesPrev2NZ.length) === 0}
            filenameBase="weekly-rebates"
            sheetName="Weekly Rebates"
            columns={[
              { key: "user_code", header: "User Code" },
              { key: "rebate", header: "Rebate" },
              { key: "__week", header: "Week" },
            ]}
            rows={[
              ...rebatesCurNZ.map(r => ({ ...r, __week: "Current" })),
              ...rebatesPrev1NZ.map(r => ({ ...r, __week: "Previous" })),
              ...rebatesPrev2NZ.map(r => ({ ...r, __week: "Week Before Previous" })),
            ]}
          />
        </div>
      )}
      {loading ? (
        <div className="text-muted">Loading…</div>
      ) : (
        <>
          <h6 className="mb-2">Current Week</h6>
          <table className="table table-sm table-bordered table-striped mb-3">
            <thead>
              <tr>
                <th>User Code</th>
                <th>Rebate</th>
              </tr>
            </thead>
            <tbody>
              {rebatesCurNZ.map((entry, idx) => (
                <tr key={`cur-${idx}`}>
                  <td>{entry.user_code}</td>
                  <td>{entry.rebate}</td>
                </tr>
              ))}
              {rebatesCurNZ.length === 0 && (
                <tr><td colSpan="2" className="text-center text-muted">No data</td></tr>
              )}
            </tbody>
          </table>

          <h6 className="mb-2">Previous Week</h6>
          <table className="table table-sm table-bordered table-striped mb-3">
            <thead>
              <tr>
                <th>User Code</th>
                <th>Rebate</th>
              </tr>
            </thead>
            <tbody>
              {rebatesPrev1NZ.map((entry, idx) => (
                <tr key={`prev1-${idx}`}>
                  <td>{entry.user_code}</td>
                  <td>{entry.rebate}</td>
                </tr>
              ))}
              {rebatesPrev1NZ.length === 0 && (
                <tr><td colSpan="2" className="text-center text-muted">No data</td></tr>
              )}
            </tbody>
          </table>

          <h6 className="mb-2">Week Before Previous</h6>
          <table className="table table-sm table-bordered table-striped">
            <thead>
              <tr>
                <th>User Code</th>
                <th>Rebate</th>
              </tr>
            </thead>
            <tbody>
              {rebatesPrev2NZ.map((entry, idx) => (
                <tr key={`prev2-${idx}`}>
                  <td>{entry.user_code}</td>
                  <td>{entry.rebate}</td>
                </tr>
              ))}
              {rebatesPrev2NZ.length === 0 && (
                <tr><td colSpan="2" className="text-center text-muted">No data</td></tr>
              )}
            </tbody>
          </table>
        </>
      )}
    </div>
  </div>
);

export default WeeklyRebatesTab;
